import api from './api';

export const familyService = {
  getMembers: async () => api.get('/family/members'),
  getInvites: async () => api.get('/family/invites'),
  inviteMember: async (data) => api.post('/family/invite', data),
  cancelInvite: async (inviteId) => api.delete(`/family/invites/${inviteId}`),
  resendInvite: async (inviteId) => api.post(`/family/invites/${inviteId}/resend`),
  removeMember: async (userId) => api.delete(`/family/members/${userId}`),
  updateMemberRole: async (userId, role) => api.put(`/family/members/${userId}/role`, { role }),
  transferOwnership: async (userId) => api.post('/family/transfer-ownership', { userId }),
  acceptInvite: async (data) => api.post('/family/accept', data),
  getDashboard: async () => api.get('/family/dashboard'),
};
